/**
 * متنِ کپی‌شدنی (v2.132.0) — کلیک روی خودِ متن یا آیکونِ کنارش ⇒ کلیپ‌بورد.
 *
 * کاربر (۱۴۰۵/۰۷/۰۵): «کنارِ شبا و ماندهٔ مبلغ یک دکمهٔ کپی بگذار که لازم نباشد هی سلکت کنیم؛ روی متن‌ها هم که کلیک
 * می‌کنیم خودکار برود تو کلیپ‌بورد». `copy` مقدارِ خامِ کپی است (مثلاً مبلغ بدونِ جداکننده)؛ `children` نمایش.
 */
import React from "react";
import { Tooltip, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

function legacyCopy(t) {
  // روشِ قدیمی — در مرورگرها/پنجره‌هایی که Clipboard API را مسدود می‌کنند (یا صفحهٔ بی‌فوکوس) هنوز کار می‌کند
  const ta = document.createElement("textarea");
  ta.value = t;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed"; ta.style.top = "0"; ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.focus(); ta.select();
  try { ta.setSelectionRange(0, t.length); } catch { /* iOS */ }
  let ok = false;
  try { ok = document.execCommand("copy"); } catch { ok = false; }
  document.body.removeChild(ta);
  return ok;
}

export async function copyToClipboard(text) {
  const t = String(text ?? "");
  let ok = false;
  if (navigator.clipboard && window.isSecureContext) {
    try { await navigator.clipboard.writeText(t); ok = true; } catch { ok = false; }
  }
  if (!ok) ok = legacyCopy(t);          // 🐞 v2.132.0: قبلاً اگر API رد می‌کرد مستقیم «کپی نشد»
  if (ok) message.success({ content: `کپی شد: ${t}`, duration: 1.5 });
  else message.error("کپی نشد — متن را دستی انتخاب کنید");
  return ok;
}

export default function CopyText({ copy, children, mono = false, style }) {
  const value = copy ?? (typeof children === "string" || typeof children === "number" ? String(children) : "");
  if (value === "" || value == null) return <span style={{ color: "#bbb" }}>—</span>;
  const onClick = (e) => { e.stopPropagation(); copyToClipboard(value); };
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, ...style }}>
      <Tooltip title="کلیک = کپی" mouseEnterDelay={0.6}>
        <span onClick={onClick} style={{ cursor: "copy", fontFamily: mono ? "monospace" : undefined,
          fontSize: mono ? 12 : undefined, direction: mono ? "ltr" : undefined }}>
          {children ?? value}
        </span>
      </Tooltip>
      <CopyOutlined onClick={onClick} style={{ color: "var(--gx-primary, #1F4E79)", cursor: "pointer", fontSize: 13 }}
        aria-label="کپی" />
    </span>
  );
}
